module.exports = __webpack_public_path__ + "img/zimmer-frei-8.fc6f35c1.jpg";